import React from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

/**
 * Sponsorship-request modal with the optional intro note.
 *
 * Extracted verbatim from src/pages/SponsorProfile.jsx during the code-quality
 * pass: markup, copy, data-testids and behaviour are unchanged.
 */
export default function RequestSponsorshipDialog({
  open,
  displayName,
  note,
  setNote,
  requesting,
  onClose,
  onSubmit,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#1F2A2E]/50" onClick={onClose} />
      <div
        data-testid="request-dialog"
        className="relative w-full max-w-md bg-white rounded-2xl border border-[#E3DED4] shadow-2xl p-6"
      >
        <h3 className="font-display text-xl font-bold text-[#1F2A2E]">
          Request sponsorship from {displayName}
        </h3>
        <p className="mt-2 text-sm text-[#4B5A60]">
          They will see a short note from you and can accept or decline. A private conversation
          opens only if they accept.
        </p>
        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={4}
          data-testid="request-note-input"
          placeholder="Share a little about where you are in your recovery and what you are looking for."
          className="mt-4 bg-white border-[#E3DED4]"
        />
        <div className="mt-5 flex gap-2">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 bg-white border-[#E3DED4]"
          >
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={requesting}
            data-testid="submit-request-button"
            className="flex-1 bg-[#1F6F78] hover:bg-[#185B62] text-white"
          >
            Send request
          </Button>
        </div>
      </div>
    </div>
  );
}
